import Link from "next/link";
import React from "react";
import { Typography, theme } from "antd";
import { isDateParts } from "src/utils/date";
import { Time } from "./Time";

const datePattern = /^\d{4}-\d{2}-\d{2}/;

export const AttributeField = (props: {
  value: any;
  expandable?: boolean;
  format?: string | boolean;
  style?: React.CSSProperties;
  className?: string;
}) => {
  const { token } = theme.useToken();
  const value = props.value;
  const expandable = props.expandable === undefined ? true : props.expandable;
  if (value === null || value === undefined) return <>N/A</>;
  if (typeof value === "object") {
    //test if object is array
    if (Array.isArray(value)) {
      return (
        <ul>
          {(value as Array<any>).map((item: any) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      );
    }
    if (isDateParts(value)) {
      return <Time value={value} />;
    }
  }
  if (typeof value !== "string" && value.length < 100) {
    return <span>{JSON.stringify(value)}</span>;
  }
  if (typeof value !== "string" && value.length >= 100) {
    return (
      <Typography.Paragraph
        ellipsis={{ rows: 2, expandable: expandable }}
        style={props.style}
        className={props.className}
      >
        {JSON.stringify(value)}
      </Typography.Paragraph>
    );
  }
  if (datePattern.test(value)) {
    return <Time value={value} />;
  }
  if (typeof value === "string" && value.startsWith("https://")) {
    return (
      <Link
        href={value}
        target="_blank"
        style={{ display: "flex", ...props.style }}
        className={props.className}
      >
        <div style={{ paddingRight: 4 }}>
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13 5L13 1M13 1H9M13 1L7.66667 6.33333M5.66667 2.33333H4.2C3.0799 2.33333 2.51984 2.33333 2.09202 2.55132C1.71569 2.74307 1.40973 3.04903 1.21799 3.42535C1 3.85318 1 4.41323 1 5.53333V9.8C1 10.9201 1 11.4802 1.21799 11.908C1.40973 12.2843 1.71569 12.5903 2.09202 12.782C2.51984 13 3.0799 13 4.2 13H8.46667C9.58677 13 10.1468 13 10.5746 12.782C10.951 12.5903 11.2569 12.2843 11.4487 11.908C11.6667 11.4802 11.6667 10.9201 11.6667 9.8V8.33333"
              stroke={token.colorTextSecondary}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <div className="trunc">{value.replace("https://", "")}</div>
      </Link>
    );
  }
  return (
    <Typography.Paragraph
      ellipsis={{ rows: 2, expandable: expandable }}
      style={props.style}
      className={props.className}
    >
      {value}
    </Typography.Paragraph>
  );
};
